// imports
import JsonApiCollection from '$dependencies/JsonApiCollection';
import BinSurfaceModel from '$models/bin/BinSurfaceModel';
import Config from '$root/Config';

// class definition
export default class BinSurfaceCollection extends JsonApiCollection {
	// constructor
	constructor(args = {}) {
		// clone args to do some modifications
		args = Object.assign({}, args);
		args.Model = args.Model || BinSurfaceModel;
		args.config = {
			url: Config.getUrl('binSurfaces'),
		};
		args.jsonApi = { order: { weight: 'asc' } };
		// call super constructor
		super(args);
	}
}
